import { DefaultModal } from '@components/v2/ui/DefaultModal';
import { useOffsetCreation } from '@features/offsets/hooks/useOffsetCreation';
import { useOffsetProjectAdditional } from '@features/offsets/hooks/useOffsetProjectAdditional';
import { useOffsetProjectMesurability } from '@features/offsets/hooks/useOffsetProjectMesurability';
import { Box } from '@mantine/core';
import { useForm } from '@mantine/form';
import useStore from '@store/index';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import StepperHeader from '../StepperHeader/StepperHeader';
import classes from './CreateOffset.module.css';
import Step1 from './Step1/Step1';
import Step2 from './Step2/Step2';
import Step3 from './Step3/Step3';
import Step4 from './Step4/Step4';

const CreateOffset = () => {
	/* ******************************** STATES ******************************* */

	// Validators
	const form = useForm({
		initialValues: {
			name: '',
			brand: null,
			quantity: 0,
			startDate: null,
			endDate: null,
			tags: [],
		},
		validate: {
			name: (value) =>
				value.length < 2
					? t('errors.nameMustHaveAtLeast2Letters')
					: null,
			brand: (value) =>
				value == null
					? t('errors.brandIsRequired')
					: null,
			tags: (value) =>
				value.length == 0
					? t('errors.tagsIsRequired')
					: null,
			quantity: (value) =>
				value == 0
					? t('errors.quantityCannotBeZero')
					: null,
			startDate: (value) =>
				value == null
					? t('errors.startDateIsRequired')
					: null,
			endDate: (value) =>
				value == null
					? t('errors.endDateIsRequired')
					: null,
		},
	});

	const { t } = useTranslation();
	const {
		setIsAddOffset,
		currentStepOffsetCreate,
		setCurrentStepOffsetCreate,
		setOffsetCreationActiveStep,
		setOffsetCreationDatas,
		setOffsetAdditionalProjectsPage,
		setOffsetOpenDrawer,
		setOffsetAdditionalProjects,
		setOffsetAdditionalProjectsSelected,
		setOffsetMesurabilityProjects,
		setOffsetMesurabilityProjectsSelected,
		setOffsetProjectMixinAco2,
		setOffsetProjectMixinAddi,
		setOffsetStep2Error,
		setOffsetStep3Error,
		setOffsetMesurabilityProjectsPage,
		offsetAdditionalProjectsSelected,
		offsetMesurabilityProjectsSelected,
		setIsOpenModalCancelAddOffset,
		isOpenModalCancelAddOffset,
	} = useStore();

	const { handleConfirmCreateOffset } =
		useOffsetCreation();

	const { handleNextStep: handleNextToStep3 } =
		useOffsetProjectMesurability();

	const { handleNextStep: handleNextToStep4 } =
		useOffsetProjectAdditional();

	const handleNext = () => {
		if (currentStepOffsetCreate == 1) {
			setOffsetMesurabilityProjectsSelected(
				offsetMesurabilityProjectsSelected.filter(
					(item) =>
						item.quantitytco2eq !== 0 &&
						item.quantitytco2eq !== ''
				)
			);
			handleNextToStep3();
		} else if (currentStepOffsetCreate == 2) {
			setOffsetAdditionalProjectsSelected(
				offsetAdditionalProjectsSelected.filter(
					(item) => item.price !== 0 && item.price !== ''
				)
			);
			handleNextToStep4();
		} else if (currentStepOffsetCreate == 3) {
			handleConfirmCreateOffset();
		} else {
			form.validate();
		}

		if (form.isValid() && currentStepOffsetCreate < 4)
			setCurrentStepOffsetCreate(
				currentStepOffsetCreate + 1
			);
	};

	const handlePrevious = () => {
		if (currentStepOffsetCreate > 0)
			setCurrentStepOffsetCreate(
				currentStepOffsetCreate - 1
			);
	};

	const handleCancel = () => {
		setOffsetOpenDrawer(false);
		setOffsetAdditionalProjects([]);
		setOffsetAdditionalProjectsSelected([]);
		setOffsetMesurabilityProjects([]);
		setOffsetMesurabilityProjectsSelected([]);
		setOffsetProjectMixinAco2([]);
		setOffsetProjectMixinAddi([]);
		setOffsetStep2Error(false);
		setOffsetStep3Error(false);
		setOffsetCreationDatas({});
		setOffsetMesurabilityProjectsPage(1);
		setOffsetAdditionalProjectsPage(1);
		setIsOpenModalCancelAddOffset(true);
	};

	useEffect(() => {
		window.scrollTo({ top: 0 });
	}, [currentStepOffsetCreate]);

	useEffect(() => {
		if (form.values) {
			setOffsetCreationDatas({
				...form.values,
				selectedMesurabilityProjects: [],
				selectedAdditionalProjects: [],
			});
		}
	}, [form.values]);

	return (
		<Box className={classes['main-layout']}>
			<DefaultModal
				opened={isOpenModalCancelAddOffset}
				onConfirm={() => {
					handleCancel();
					setIsOpenModalCancelAddOffset(false);
					form.reset();
					setIsAddOffset(false);
					setCurrentStepOffsetCreate(0);
					setOffsetCreationActiveStep(0);
				}}
				onClose={() => {
					setIsOpenModalCancelAddOffset(false);
				}}
				title={
					location.pathname === '/offsets'
						? t('offsets.backToAllOffsetsSure')
						: t('offsets.backToDashboardSure')
				}
			/>
			<StepperHeader
				onCancel={() =>
					setIsOpenModalCancelAddOffset(true)
				}
				onPrevious={handlePrevious}
				onNext={handleNext}
				activeStep={currentStepOffsetCreate}
			/>

			{currentStepOffsetCreate == 0 && (
				<Step1 form={form} />
			)}
			{currentStepOffsetCreate == 1 && <Step2 />}
			{currentStepOffsetCreate == 2 && <Step3 />}
			{currentStepOffsetCreate == 3 && <Step4 />}
		</Box>
	);
};

export default CreateOffset;
